import * as Sentry from '@sentry/react';
import { setRuntimeContext } from './runtimeContext';

/**
 * Update loan context in Sentry and runtime context
 * This function should be called when loan selection changes
 */
export function updateLoanContextInSentry(loan: { _id: string; state?: string | null } | null | undefined): void {
  if (loan?._id) {
    Sentry.setTag('loanId', loan._id);
    Sentry.setContext('loan', {
      id: loan._id,
      state: loan.state || null,
    });
    setRuntimeContext({ 
      loan: { 
        id: loan._id, 
        state: loan.state || null 
      } 
    });
  } else {
    Sentry.setTag('loanId', 'none');
    Sentry.setContext('loan', { id: null, state: null });
    setRuntimeContext({ loan: { id: null, state: null } });
  }
}

